import { render, staticRenderFns } from "./Organize.vue?vue&type=template&id=6bbb212f&scoped=true"
import script from "./Organize.vue?vue&type=script&lang=js"
export * from "./Organize.vue?vue&type=script&lang=js"
import style0 from "./Organize.vue?vue&type=style&index=0&id=6bbb212f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb212f",
  null
  
)

export default component.exports